import type {ReactElement} from 'react';
import React from 'react';
import type {IconWithTooltipProps} from './icon-with-tooltip.types';
import {TooltipPlacement} from './icon-with-tooltip.types';
import styles from './icon-with-tooltip.module.scss';
import {Icon} from '@Components/icon-v2';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {TOOLTIP_POSITION} from '@Components/tooltip';
import {getClassesForPosition} from '@Components/tooltip/tooltip-helper';

export function IconWithTooltip({arrowPosition, tooltipText, hideArrow = false, placement = TooltipPlacement.TOP, ...props}: IconWithTooltipProps): ReactElement<any> {
  const resolvedArrowPosition = arrowPosition ?? deriveArrowPositionFromPlacement(placement);
  const tooltipClassName = ['spacing-m-b-1', hideArrow ? null : '_rounded-arrow', getClassesForPosition(resolvedArrowPosition), styles.tooltip].filter(Boolean).join(' ');
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      overlay={<Tooltip className={tooltipClassName}>{tooltipText}</Tooltip>}
      delay={{show: 0, hide: props.toolTipHideDelay ?? 0}}
      placement={placement}
      offset={props.offset ? [props.offset.x, props.offset.y] : undefined}
    >
      <Icon {...props} className={props.className} />
    </OverlayTrigger>
  );
}

function deriveArrowPositionFromPlacement(placement: TooltipPlacement): TOOLTIP_POSITION {
  switch (placement) {
    case TooltipPlacement.BOTTOM:
      return TOOLTIP_POSITION.TOP_MIDDLE;
    case TooltipPlacement.LEFT:
      return TOOLTIP_POSITION.BOTTOM_RIGHT;
    case TooltipPlacement.RIGHT:
      return TOOLTIP_POSITION.BOTTOM_LEFT;
    case TooltipPlacement.TOP:
    default:
      return TOOLTIP_POSITION.BOTTOM_MIDDLE;
  }
}
